package uz.ferro.erp.feature.visit.model

enum class VisitStatus {
    STARTED,
    COMPLETED
}